import React from 'react';
import { CommonPrelanderV2 } from '../../components/CommonPrelanderV2';
import { QUIZ_SLIDES_V28 } from '../../shared/quiz-slides/quiz-slides-v28';

function PrelanderV47Page({ initialPrelander }) {
    return (
        <CommonPrelanderV2
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V28}
        />
    );
}

export {
    PrelanderV47Page
};
